import { render, staticRenderFns } from "./TambahSertifikatPenelitiKeamanan.vue?vue&type=template&id=676f26eb&scoped=true&"
import script from "./TambahSertifikatPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./TambahSertifikatPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f26eb",
  null
  
)

export default component.exports